'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translateUtils = require('./translateUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _translateUtils.translate)(function (_ref) {
  var t = _ref.t;
  return _react2.default.createElement(
    'span',
    null,
    t('Loading')
  );
});


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/LoadingView.js
// module id = 710
// module chunks = 118